import * as React from 'react';
import {Button as MuiButton} from '@mui/material';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import {FC} from "react";
import {makeStyles, Theme, withStyles} from "@material-ui/core";

export const Button = withStyles({
  root: {
    color: '#FFF !important',
    background: 'rgba(255, 255, 255, 0.1) !important',
    borderRadius: '6px !important',
    minWidth: '48px !important',
  },
})(MuiButton);

const menuStyle = {
  list: {
    style: {
      // paddingTop: 3,
      // paddingBottom: 3,
      backgroundColor: '#1F2C3E',
      color: '#FFFFFF'
      // borderRadius: 8,
      // fontSize: 20
    }
  },
  paper: {
    style: {
      backgroundColor: '#1F2C3E',
      // transform: 'translateX(5%) translateY(35%)'
    }
  }
}

type PropsType = {
  id?: string;
  children: any;
  items: string[]
  h?: string;
  w?: string;
  onClick: any;
}

const DropdownButton: FC<PropsType> = ({
  id = 'dropdown-button',
  children,
  items,
  h= '42px',
  w= '48px',
  onClick
}) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <React.Fragment>
      <Button
        style={{height: h, width: w}}
        id={id}
        aria-controls={open ? `${id?.trim()}-menu` : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
      >
        {children}
      </Button>
      <Menu
        PaperProps={menuStyle.paper}
        MenuListProps={menuStyle.list}
        id={`${id?.trim()}-menu`}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        {items.map((i, index) => (
          <MenuItem key={index} onClick={() => {
            onClick()
            handleClose()
          }}>{i}</MenuItem>
        ))}
      </Menu>
    </React.Fragment>
  );
}

export default DropdownButton
